import React, {Component} from 'react';
import {Button, Table} from 'semantic-ui-react';
import {FormattedNumber} from "react-intl";
import {connect} from "react-redux";
import {expenseDetailDelete} from "../../actions/ExpenseDetailActions";
import expenseDetailData from "../../data/ExpenseDetailData";
import {showAlert} from "../../actions/AlertAction";

class ExpenseRow extends Component {
    constructor(){
        super();
        this.state = {
            loading:false,
        }
    };

    delete = () =>{
        expenseDetailData.delete(this.props.id, (res) =>{
            if(res.delete){
                this.setState({loading:false});
                this.props.expenseDetailDelete(this.props.id);
            }else{
                this.setState({loading:false});
                this.props.showAlert({type:'error', message:'No hay conexión a internet!', show:true});
            }
        })
    };

    render() {
        return (
            <Table.Row>
                <Table.Cell>{`${this.props.quantity} ${this.props.ingredient ? this.props.ingredient.unit:'unid.'}`}</Table.Cell>
                <Table.Cell>
                    <strong>{`${this.props.ingredient ? this.props.ingredient.name:this.props.product.name}`}</strong>
                </Table.Cell>
                <Table.Cell textAlign='right'>
                    $<FormattedNumber value={this.props.price} currency="USD" maximumFractionDigits={0}
                                      minimumFractionDigits={0}/>
                </Table.Cell>
                <Table.Cell>
                    <Button icon='trash' size='tiny' onClick={this.delete} loading={this.state.loading} disabled={this.state.loading}/>
                </Table.Cell>
            </Table.Row>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        expenseDetailDelete(expense_detail) {
            dispatch(expenseDetailDelete(expense_detail))
        },
        showAlert(alert){
            dispatch(showAlert(alert))
        },
    }
}

export default connect(
    null,
    mapDispatchToProps
)(ExpenseRow)



// WEBPACK FOOTER //
// ./src/components/expenses/ExpenseRow.js